export {
  BODY_TYPE_CATEGORIES,
  BODY_TYPE_LABELS,
  BODY_TYPE_LEGACY_LABELS,
  bodyTypeLabelAr,
  bodyTypeLabelBoth,
  type BodyTypeCategory,
} from "@shared/body-type";
import type { BodyTypeCategory } from "@shared/body-type";

/** Images in `client/public/category-images/` */
const CATEGORY_IMG_V = "4";

/** White-studio JPEG/PNG · use multiply blend on light cards */
export const BODY_TYPE_WHITE_BG: Partial<Record<BodyTypeCategory, boolean>> = {
  Hatchback: true,
  Van: true,
};

/** Flip horizontally so silhouette faces same direction as other categories (→). */
export const BODY_TYPE_MIRROR: Partial<Record<BodyTypeCategory, boolean>> = {
  Hatchback: true,
  Van: true,
};

export const BODY_TYPE_IMAGES: Record<BodyTypeCategory, string> = {
  SUV: `/category-images/suv-land-rover-01.png?v=${CATEGORY_IMG_V}`,
  Sedan: `/category-images/sedan-330e-01.png?v=${CATEGORY_IMG_V}`,
  Coupe: `/category-images/coupe-mercedes-01.png?v=${CATEGORY_IMG_V}`,
  Convertible: `/category-images/convert-mercedes-01.png?v=${CATEGORY_IMG_V}`,
  Hatchback: `/category-images/hatchback.png?v=${CATEGORY_IMG_V}`,
  Wagon: `/category-images/station-wagon.png?v=${CATEGORY_IMG_V}`,
  Van: `/category-images/van.png?v=${CATEGORY_IMG_V}`,
};

